import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: ':language',
        loadChildren: () =>
            import('./pages/pages.module').then((c) => c.PagesModule),
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'es',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            scrollOffset: [0, 70],
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
